// src/graphql/products.ts
import { gql } from "@apollo/client";

/** Public listing query with filters + pagination */
export const PRODUCTS_LIST_QUERY = gql`
  query ProductsList(
    $bestSeller: Boolean
    $productType: String
    $metal: String
    $offset: Int
    $limit: Int
    $order: String
  ) {
    publicProducts(
      bestSeller: $bestSeller
      productType: $productType
      metal: $metal
      offset: $offset
      limit: $limit
      order: $order
    ) {
      id
      name
      slug
      altText
      customSchema
      productType
      metal
      shortDescription
      longDescription
      price
      galleryImages
      rotationImages
    }
    publicProductsCount(productType: $productType, metal: $metal)
  }
`;

export const BEST_SELLERS_PREVIEW_QUERY = gql`
  query BestSellersPreview($limit: Int) {
    bestSellersPreview(limit: $limit) {
      id
      name
      slug
      altText
      productType
      price
      primaryImage
    }
  }
`;

export const PRODUCT_MEDIA_QUERY = gql`
  query ProductMedia($id: ID!) {
    productMedia(id: $id) {
      id
      galleryImages
      rotationImages
    }
  }
`;

export const ADMIN_PRODUCTS_QUERY = gql`
  query AdminProducts {
    products {
      id
      name
      slug
      altText
      customSchema
      productType
      metal
      shortDescription
      longDescription
      price
      bestSeller
      rotationImages
      galleryImages
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProduct(
    $name: String!
    $productType: String!
    $metal: String!
    $shortDescription: String
    $longDescription: String
    $altText: String
    $customSchema: String
    $price: Float!
    $bestSeller: Boolean!
    $rotationImages: [String!]
    $galleryImages: [String!]
  ) {
    createProduct(
      input: {
        name: $name
        productType: $productType
        metal: $metal
        shortDescription: $shortDescription
        longDescription: $longDescription
        altText: $altText
        customSchema: $customSchema
        price: $price
        bestSeller: $bestSeller
        rotationImages: $rotationImages
        galleryImages: $galleryImages
      }
    ) {
      product {
        id
        name
        slug
        altText
        customSchema
        productType
        metal
        shortDescription
        longDescription
        price
        bestSeller
        rotationImages
        galleryImages
      }
      errors
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct(
    $id: ID!
    $name: String!
    $productType: String!
    $metal: String!
    $shortDescription: String
    $longDescription: String
    $altText: String
    $customSchema: String
    $price: Float!
    $bestSeller: Boolean!
    $rotationImages: [String!]
    $galleryImages: [String!]
  ) {
    updateProduct(
      input: {
        id: $id
        name: $name
        productType: $productType
        metal: $metal
        shortDescription: $shortDescription
        longDescription: $longDescription
        altText: $altText
        customSchema: $customSchema
        price: $price
        bestSeller: $bestSeller
        rotationImages: $rotationImages
        galleryImages: $galleryImages
      }
    ) {
      product {
        id
        name
        slug
        altText
        customSchema
        productType
        metal
        shortDescription
        longDescription
        price
        bestSeller
        rotationImages
        galleryImages
      }
      errors
    }
  }
`;

export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(input: { id: $id }) {
      success
      errors
    }
  }
`;

/** Single product by ID used on ProductPage & for WhatsApp links */
export const PRODUCT_BY_SLUG_QUERY = gql`
  query ProductBySlug($slug: String!) {
    product(slug: $slug) {
      id
      slug
      altText
      customSchema
      name
      productType
      metal
      shortDescription
      longDescription
      price
      galleryImages
      rotationImages
    }
  }
`;
